var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 1,
    fill: "#EC6240"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.17272C5 5.55741 5.55041 5.08807 6.15799 5.18528L29.158 8.86528C29.6431 8.9429 30 9.36142 30 9.85272V45H6C5.44772 45 5 44.5523 5 44V6.17272Z",
    fill: "#667C89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.17272C5 5.55741 5.55041 5.08807 6.15799 5.18528L17.5 7V45H6C5.44772 45 5 44.5523 5 44V6.17272Z",
    fill: "#596C78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L44.2577 23.802C44.6954 23.9188 45 24.3152 45 24.7683V44C45 44.5523 44.5523 45 44 45H30V20Z",
    fill: "#94A3AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20L37.5 22V45H30V20Z",
    fill: "#808E96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36C13 34.8954 13.8954 34 15 34H20C21.1046 34 22 34.8954 22 36V45H13V36Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36C13 34.8954 13.8954 34 15 34H17.5V45H13V36Z",
    fill: "#CDD0D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 27,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 28.5C16.5 29.3284 15.8284 30 15 30L12 30C11.1716 30 10.5 29.3284 10.5 28.5L16.5 28.5Z",
    fill: "#CDD0D2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 22,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 17,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 12,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 27,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 22,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 37,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 17,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 32,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 27,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 23.5C16.5 24.3284 15.8284 25 15 25L12 25C11.1716 25 10.5 24.3284 10.5 23.5L16.5 23.5Z",
    fill: "#CDD0D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 28.5C24.5 29.3284 23.8284 30 23 30L20 30C19.1716 30 18.5 29.3284 18.5 28.5L24.5 28.5Z",
    fill: "#CDD0D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 18.5C24.5 19.3284 23.8284 20 23 20L20 20C19.1716 20 18.5 19.3284 18.5 18.5L24.5 18.5Z",
    fill: "#CDD0D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 33.5C40.5 34.3284 39.8284 35 39 35L36 35C35.1716 35 34.5 34.3284 34.5 33.5L40.5 33.5Z",
    fill: "#CDD0D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 13.5C24.5 14.3284 23.8284 15 23 15L20 15C19.1716 15 18.5 14.3284 18.5 13.5L24.5 13.5Z",
    fill: "#CDD0D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 28.5C40.5 29.3284 39.8284 30 39 30L36 30C35.1716 30 34.5 29.3284 34.5 28.5L40.5 28.5Z",
    fill: "#CDD0D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 13.5C16.5 14.3284 15.8284 15 15 15L12 15C11.1716 15 10.5 14.3284 10.5 13.5L16.5 13.5Z",
    fill: "#CDD0D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 23.5C24.5 24.3284 23.8284 25 23 25L20 25C19.1716 25 18.5 24.3284 18.5 23.5L24.5 23.5Z",
    fill: "#CDD0D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 38.5C40.5 39.3284 39.8284 40 39 40L36 40C35.1716 40 34.5 39.3284 34.5 38.5L40.5 38.5Z",
    fill: "#CDD0D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 18.5C16.5 19.3284 15.8284 20 15 20L12 20C11.1716 20 10.5 19.3284 10.5 18.5L16.5 18.5Z",
    fill: "#CDD0D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.bdbf0ed3.svg";
export { ForwardRef as ReactComponent };